import React from 'react';
import { Link } from 'react-router-dom';
import { actorInfo } from '../mock/komalData';
import { Heart } from 'lucide-react';
import LetterboxdIcon from './LetterboxdIcon';
import ImdbIcon from './ImdbIcon';

const FooterKomal = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-800 py-12 px-6 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="font-display text-3xl font-black text-white mb-2">
              KOMAL <span className="text-[#FF6B6B]">VERMA</span>
            </h3>
            <p className="text-gray-400">
              {actorInfo.tagline}
            </p>
            <p className="text-gray-500 text-sm mt-4">
              Mumbai, India
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Quick Links</h4>
            <ul className="space-y-2">
              {['home', 'about', 'showreel', 'portraits', 'skills', 'shades', 'work', 'unreleased', 'contact'].map((section) => (
                <li key={section}>
                  <button
                    onClick={() => scrollToSection(section)}
                    className="text-gray-400 hover:text-[#FF6B6B] transition-colors capitalize"
                  >
                    {section === 'shades' ? 'Languages' : section === 'unreleased' ? 'Unreleased Work' : section}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Contact</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <a href={`mailto:${actorInfo.email}`} className="hover:text-[#FF6B6B] transition-colors">
                  {actorInfo.email}
                </a>
              </li>
              <li>
                <a href={`tel:${actorInfo.phone}`} className="hover:text-[#FF6B6B] transition-colors">
                  {actorInfo.phone}
                </a>
              </li>
              <li className="pt-4">
                <div className="flex flex-wrap gap-2 lg:gap-3">
                  <a
                    href={actorInfo.showreelUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-6 py-2 bg-[#FF6B6B]/10 border border-[#FF6B6B]/30 text-[#FF6B6B] rounded-lg hover:bg-[#FF6B6B]/20 transition-colors"
                  >
                    View Showreel
                  </a>
                  <Link
                    to="/portfolio"
                    className="inline-block px-6 py-2 bg-[#FFD700]/10 border border-[#FFD700]/30 text-[#FFD700] rounded-lg hover:bg-[#FFD700]/20 transition-colors"
                    data-testid="footer-portfolio-link"
                  >
                    View Portfolio
                  </Link>
                  {actorInfo.imdb && (
                    <a
                      href={actorInfo.imdb}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="footer-imdb-link"
                      className="inline-flex items-center gap-2 px-6 py-2 bg-[#F5C518]/10 border border-[#F5C518]/30 text-[#F5C518] rounded-lg hover:bg-[#F5C518]/20 transition-colors"
                    >
                      <ImdbIcon size={16} />
                      IMDb
                    </a>
                  )}
                  {actorInfo.letterboxd && (
                    <a
                      href={actorInfo.letterboxd}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="footer-letterboxd-link"
                      className="inline-flex items-center gap-2 px-6 py-2 bg-[#00E054]/10 border border-[#00E054]/30 text-[#00E054] rounded-lg hover:bg-[#00E054]/20 transition-colors"
                    >
                      <LetterboxdIcon size={16} />
                      Letterboxd
                    </a>
                  )}
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500 flex items-center justify-center gap-2 flex-wrap">
            <span>© {currentYear} Komal Verma. All rights reserved.</span>
            <span className="hidden sm:inline">|</span>
            <span className="flex items-center gap-1">
              Made with <Heart size={14} className="text-[#FF6B6B] fill-[#FF6B6B]" /> for authentic storytelling
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterKomal;
